<template>
  <div class="outer-wrapper">
    <div v-if="currentWarehouse.display_no" v-show="sw==='info'">
      <van-nav-bar
        title="库位详情"
      >
      </van-nav-bar>
      <van-cell :value="currentWarehouse.display_no" value-class="title-p" />
      <!-- <van-cell :value="''" value-class="sub-title-p" /> -->
      <van-cell
        title="名称"
        :value="currentWarehouse.name?currentWarehouse.name:'-'"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="说明"
        value-class="prop-value"
        title-class="prop-title"
        :label="currentWarehouse.remark?currentWarehouse.remark:'-'"
      />
      <!-- <van-divider /> -->
      <van-cell
        title="查看历史存放"
        is-link
        @click="goTab('history')"
      />
      <van-cell
        title="当前存放物品："
        :value="currentWarehouse.currentGoods.length===0?'空':''"
      />
      <van-cell
      v-for="(ele,index) in currentWarehouse.currentGoods"
      :key="index"
        :title="categoryFac(ele.target_category)"
        :value="ele.sn"
        :label="ele.name"
        is-link
        @click="goUrl(ele)"
      />
    </div>
    
    <div v-else-if="!currentWarehouse.name">
      <van-empty description="该库位信息已失效（重新规划后删除...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
    <div v-show="sw==='history'">
      <van-nav-bar
      title="库位历史存放记录"
      left-text="返回"
      left-arrow
      @click-left="changeTab('info')"
      fixed
    >
    </van-nav-bar>
    <div class="title-wrapper">
      <van-cell :value="currentWarehouse.display_no" value-class="title-p" />
    </div>

    <van-list
      v-model="tableList.loading"
      :finished="tableList.finished"
      finished-text="没有更多了"
      :error.sync="tableList.error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
      :immediate-check="false"
    >
      <van-cell
        v-for="(item, index) in tableList.tivdata"
        :key="index + 'su'"
        :title="item.in_time + '~' + item.out_time"
        :value="categoryFac(item.target_category)"
      >
        <template #label>
          <div>
            <span
              >{{ item.name}}--{{
                item.sn
              }}</span
            >
            <span style="float: right">{{ item.in_operator_name }}</span>
          </div>
        </template>
      </van-cell>
    </van-list>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
//let authData = JSON.parse(localStorage.getItem("authData"));

function myTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

export default {
  name: "warehouseInfo",
  components: {},
  props: {
    enid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentWarehouse: {},
      sw:'info',
      tableList: myTableFac(),
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getData();
    this.inOp();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "warehouseInfo",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok"&&response.data.res_record.length>0) {
            this.currentWarehouse = response.data.res_record[0];
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    onLoad() {
      this.tableList.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.tableList.Tpage,
          userToken: userToken,
          ask_data: "warehouseHistory",
          enid: this.enid,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.tableList.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.tableList.Tpage.currentSize
          ) {
            this.tableList.finished = true;
          }
          this.tableList.loading = false;
          this.tableList.Tpage.currentPage++;
        });
    },
    inOp() {
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "inOp",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("入库成功！");
            setTimeout(()=>{
              this.$router.go(-1);
            },1000);
          }
        });
    },
    categoryFac(value){
      if(value==='sample'){
        return '样品';
      }else if(value==='package'){
        return '包裹';
      }else{
        return '其他';
      }
    },
    goUrl(ele){
      if(ele.target_category==='sample'){
        location.href = '/sampleInfo/'+ele.enid;
      }else if(ele.target_category==='package'){
        location.href = '/packageOp/'+ele.enid;
      }
    },
    changeTab(value){
      this.sw = value;
    },
    goTab(value){
      this.changeTab(value);
      this.onLoad();
    }
    
  },
};
</script>
<style scoped>
.title-p {
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
  line-height: 2rem;
  height:2rem;
}
.sub-title-p {
  text-indent: 1.2rem;
  color: #999;
}

.prop-title {
  color: #999;
  font-size: 0.4rem;
}
.prop-value {
  color: #333;
  font-size: 0.7rem;
}
.spin {
  text-align: center;
  padding-top: 40%;
}

.sample-list-wrapper {
  text-align: center;
  width: 100%;
  word-break: break-all;
}

.sample-list-inner-wrapper {
  margin: 0.5rem 0.6rem;
}

.submit-b-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
}

.suspend-b {
  width: 6rem;
}

.record-value {
  text-indent: 1rem;
}

.submit-b-wrapper{
    position: fixed;
    bottom:0;
    display:flex;
    width:100%;
}

.suspend-b{
  width:6rem;
}


</style>